import { hFetch } from './hFetch';

export const deleteAttachment = async ({ id }: { id: string }) => {
  return await hFetch({ url: `/api/attachments/${id}`, method: 'DELETE' });
};
